import { render, staticRenderFns } from "./TopSwitch.vue?vue&type=template&id=4ffefd28&scoped=true"
import script from "./TopSwitch.vue?vue&type=script&lang=js"
export * from "./TopSwitch.vue?vue&type=script&lang=js"
import style0 from "./TopSwitch.vue?vue&type=style&index=0&id=4ffefd28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffefd28",
  null
  
)

export default component.exports